/**
 * Variant Metafields Display Handler
 * Updates the 'Your Order Includes' section based on the selected variant metafields.
 */
(function() {
  function updateVariantDetails(variant) {
    const containers = document.querySelectorAll('[data-variant-details]');
    if (containers.length === 0) return;

    let targetVariant = variant;
    
    if (targetVariant && !targetVariant.metafields) {
      const picker = document.querySelector('variant-picker');
      const variantData = picker?.variantData || JSON.parse(document.querySelector('#productVariants')?.textContent || '[]');
      targetVariant = variantData.find(v => v.id == variant.id) || targetVariant;
    }

    containers.forEach(container => {
      if (!targetVariant || !targetVariant.metafields) {
        container.style.display = 'none';
        return;
      }

      const { metafields } = targetVariant;

      const mlValues = (metafields.ml || '').split(',').map(s => s.trim());
      const mlTitles = (metafields.ml_titles || '').split(',').map(s => s.trim());
      const mlTags = (metafields.ml_tags || '').split(',').map(s => s.trim());
      const mlBottleImages = Array.isArray(metafields.ml_bottle_images)
        ? metafields.ml_bottle_images
        : [];

      const items = container.querySelectorAll('.m-variant-details__item');
      items.forEach((item, index) => {
        const iconEl = item.querySelector('.m-variant-details__icon');
        const mlEl = item.querySelector('[data-ml-value]');
        const titleEl = item.querySelector('[data-ml-title]');
        const mlLabelEl = item.querySelector('[data-ml-label]');
        const tagEl = item.querySelector('[data-ml-tag]');
        const bottleImageEl = item.querySelector('[data-ml-bottle-image]');

        if (mlEl) mlEl.textContent = mlValues[index] || '';
        if (titleEl) titleEl.textContent = mlTitles[index] || '';
        if (mlLabelEl) mlLabelEl.textContent = mlValues[index] ? mlValues[index] + ' ML' : '';

        // ✅ Tag: set text, visibility, and dynamic class based on value
        if (tagEl) {
          tagEl.textContent = mlTags[index] || '';
          tagEl.style.display = mlTags[index] ? 'inline-block' : 'none';

          // Remove any previously added tag-- classes
          tagEl.className = tagEl.className
            .replace(/\btag--\S+/g, '')
            .trim();

          // Add class based on current tag value (e.g. "Gift" → "tag--gift")
          if (mlTags[index]) {
            const tagClass = 'tag--' + mlTags[index]
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '');
            tagEl.classList.add(tagClass);
          }
        }

        // Handle bottle image vs icon
        if (bottleImageEl) {
          const imageUrl = mlBottleImages[index] || '';
          if (imageUrl) {
            bottleImageEl.src = imageUrl;
            bottleImageEl.alt = mlTitles[index] || '';
            bottleImageEl.style.display = 'block';
            if (iconEl) iconEl.style.display = 'none';
          } else {
            bottleImageEl.src = '';
            bottleImageEl.style.display = 'none';
            if (iconEl) iconEl.style.display = 'flex';
          }
        }

        // Show/hide item based on whether it has data
        const isVisible = !!(mlTitles[index] || mlValues[index]);
        item.style.display = isVisible ? 'flex' : 'none';

        // Hide the adjacent '+' separator when item is hidden
        const nextSibling = item.nextElementSibling;
        if (nextSibling && nextSibling.classList.contains('wplus')) {
          nextSibling.style.display = isVisible ? '' : 'none';
        }
      });

      // Hide the '+' that comes after the LAST visible item
      const allItems = container.querySelectorAll('.m-variant-details__item');
      let lastVisibleItem = null;
      allItems.forEach(item => {
        if (item.style.display !== 'none') lastVisibleItem = item;
      });

      if (lastVisibleItem) {
        const lastPlus = lastVisibleItem.nextElementSibling;
        if (lastPlus && lastPlus.classList.contains('wplus')) {
          lastPlus.style.display = 'none';
        }
      }

      // Update bottom texts
      const bottomText1 = container.querySelector('[data-bottom-text-1]');
      const bottomPayText = container.querySelector('[data-bottom-pay-text]');

      if (bottomText1) {
        bottomText1.innerHTML = metafields.bottom_text_1 || '';
        bottomText1.style.display = metafields.bottom_text_1 ? 'block' : 'none';
      }
      if (bottomPayText) {
        bottomPayText.textContent = metafields.bottom_pay_text || '';
        bottomPayText.style.display = metafields.bottom_pay_text ? 'flex' : 'none';
      }

      // Remove any previously added variant class
      container.className = container.className
        .replace(/\bvariant--\S+/g, '')
        .trim();

      // Add new variant class based on variant title
      if (targetVariant && targetVariant.title) {
        const variantClass = 'variant--' + targetVariant.title
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        container.classList.add(variantClass);
      }

      container.style.display = 'block';
    });
  }

  function init() {
    const picker = document.querySelector('variant-picker');
    if (picker && window.MinimogEvents) {
      const productId = picker.dataset.productId;
      
      window.MinimogEvents.subscribe(`${productId}__VARIANT_CHANGE`, (variant) => {
        updateVariantDetails(variant);
      });

      let attempts = 0;
      const checkInit = setInterval(() => {
        attempts++;
        let current = null;
        const selectedId = picker.querySelector('[name="id"]')?.value;
        const variantData = picker.variantData || JSON.parse(picker.querySelector('#productVariants')?.textContent || '[]');
        
        if (picker.currentVariant) {
          current = picker.currentVariant;
        } else if (selectedId) {
          current = variantData.find(v => v.id == selectedId);
        }

        if ((current && current.metafields) || attempts > 5) {
          updateVariantDetails(current || variantData[0]);
          clearInterval(checkInit);
        }
      }, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();